import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    header: {
        id: '_.loan_builder.header',
        defaultMessage:
            'Hi {name}, you’re approved for {offeredAmount} - valid until {timeoutDate}{tooltip}'
    },
    tooltip: {
        id: '_.loan_builder.header_tooltip',
        defaultMessage:
            "If you miss this window, you'll just need to re-apply in your iwoca account."
    }
});
